<template>
  <layout title="Notices">
    <div class="row mb-4">
      <div class="col-10 col-sm-9">
        <h2 class="page-heading">Notices</h2>
      </div>

      <div class="col-2 col-sm-3">
        <div class="btn-group float-right">
          <inertia-link class="btn btn-primary" :href="route('users.create')">
            + Add New
          </inertia-link>
          <button
            type="button"
            class="btn btn-primary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu">
            <inertia-link class="dropdown-item" :href="route('users.import')">
              Import CSV
            </inertia-link>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
      <div class="card-body">
        <FlashMessage :flash="flash" />

        <form @submit.prevent="search()">
          <div class="row mb-2">
            <div class="col-md-3">
              <select
                v-if="tenants && tenants.length"
                class="form-control"
                @change="search()"
                v-model="filters.tenant_id"
              >
                <option :value="null" :selected="filters.tenant_id === null">
                  Unassigned
                </option>
                <option
                  v-for="tenant in tenants"
                  :key="tenant.id"
                  :value="tenant.id"
                  :selected="tenant.id == filters.tenant_id"
                >
                  {{ tenant.name }}
                </option>
              </select>
            </div>
            <div class="col-md-5"></div>
            <div class="col-md-4">
              <input
                v-model="filters.search_query"
                type="text"
                class="form-control"
                placeholder="Search.."
              />
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-hover table-responsive w-100 d-md-table">
              <thead class="thead-light xthead-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Username</th>
                  <th scope="col">Student ID</th>
                  <th scope="col">Roles</th>
                  <th scope="col">Classrooms</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="user in users.data"
                  :key="user.id"
                  @click="navigateToEdit(user.id)"
                >
                  <td>{{ user.first_name + " " + user.last_name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.username }}</td>
                  <td>{{ user.student_reg_id }}</td>
                  <td>
                    <pre>{{ user.roles.map((e) => e.name).join(", ") }}</pre>
                  </td>
                  <td>{{ user.classrooms_count }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm x-btn-danger btn-outline-danger"
                      @click.stop="showDeleteConfirmationModal(user)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!users.data || !users.data.length">
                <tr>
                  <td colspan="6">No data to display</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-end">
            <li
              class="page-item"
              :class="{ active: link.active }"
              v-for="link in users.links"
              :key="link.label"
            >
              <inertia-link
                v-if="link.url"
                class="page-link"
                :href="link.url"
                preserve-scroll
              >
                <span v-html="link.label"></span>
              </inertia-link>
              <span class="page-link" v-else>
                <span v-html="link.label"></span>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div
      class="modal fade"
      id="deleteConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Record - {{ selectedRecord && selectedRecord.first_name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete the record -
            <strong>{{ selectedRecord && selectedRecord.first_name }}</strong>
            ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="deleteRecord(selectedRecord ? selectedRecord.id : null)"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    users: Object,
    tenants: Object,
    filters: {
      search_query: String,
      tenant_id: String,
    },
    flash: Object,
  },
  data() {
    return {
      selectedRecord: null,
    };
  },
  methods: {
    search() {
      const reqParams = {};

      reqParams["search_query"] = this.filters.search_query || undefined;
      reqParams["tenant_id"] = this.filters.tenant_id || undefined;

      this.$inertia.get(route("users.index"), reqParams);
    },
    showDeleteConfirmationModal(record) {
      this.selectedRecord = record;
      $("#deleteConfirmationModal").modal("show");
    },
    deleteRecord(id) {
      this.$inertia.delete(route("users.destroy", id));
    },
    navigateToEdit(Id) {
      this.$inertia.get(route("users.edit", Id));
    },
  },
};
</script>